import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  NEW_PASSWORD,
  NEW_PASSWORD_SUCCESS,
  NEW_PASSWORD_ERROR,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_ERROR,
  RESET_UPDATE_PASSWORD_ERROR,
} from "./actionTypes"

const initialState_forgetPassword = {
  forgetSuccessMsg: null,
  forgetError: null,
  loading: false,
}

const forgetPassword = (state = initialState_forgetPassword, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        loading: true,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
        loading: false,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

const initialState_resetPassword = {
  resetPasswordSuccessMsg: null,
  resetPasswordError: null,
  loading: false,
}

const resetPassword = (state = initialState_resetPassword, action) => {
  switch (action.type) {
    case NEW_PASSWORD:
      state = {
        ...state,
        resetPasswordSuccessMsg: null,
        resetPasswordError: null,
        loading: true,
      }
      break
    case NEW_PASSWORD_SUCCESS:
      state = {
        ...state,
        resetPasswordSuccessMsg: action.payload,
        loading: false,
      }
      break
    case NEW_PASSWORD_ERROR:
      state = { ...state, resetPasswordError: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

const initialState_updatePassword = {
  updatePasswordSuccessMsg: null,
  updatePasswordError: null,
  loading: false,
}

const updatePassword = (state = initialState_updatePassword, action) => {
  switch (action.type) {
    case UPDATE_PASSWORD:
      state = {
        ...state,
        updatePasswordSuccessMsg: '',
        updatePasswordError: '',
        loading: true,
      }
      break

    case UPDATE_PASSWORD_SUCCESS:
      state = {
        ...state,
        updatePasswordSuccessMsg: action.payload,
        loading: false,
        updatePasswordError: '',
        updatePasswordSuccessMsg: 'Password updated successfully'
      }
      break

    case UPDATE_PASSWORD_ERROR:
      state = { ...state, updatePasswordError: action.payload, loading: false, updatePasswordSuccessMsg: ''    }
      break

    case RESET_UPDATE_PASSWORD_ERROR:
      state = {
        ...state,
        updatePasswordError: action.payload,
        loading: false
      }
      break
      
    default:
      state = { ...state, updatePasswordSuccessMsg: '' }
      break
  }
  return state
}

export { forgetPassword, resetPassword, updatePassword }
